import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, styled, tooltipClasses } from '@mui/material';
// TODO: there is probably new component InfoTooltip or UserInputTooltip or ActionHelperTooltip in core ui. We should
// remove this one later.
const ErrorTooltip = styled(({ className, ...props }) => (_jsx(Tooltip, { ...props, arrow: true, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.error.main,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.error.main,
    },
}));
export { ErrorTooltip };
